var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('h1',[_vm._v("路径跳转失败，将在"+_vm._s(_vm.time)+"秒后跳转会首页")])])}
var staticRenderFns = []

export { render, staticRenderFns }